import { AOString } from './ao-string';

// @dynamic

export class AOArray {

  static flat(items: any[]): any[] {
    return items.reduce((acc, val) => Array.isArray(val) ? acc.concat(this.flat(val)) : acc.concat(val), []);
  }

  static distict(array) {
    return array.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });
  }

  static slug(items: string[]): string[] {
    return items.map(item => AOString.slug(item));
  }

  static keywords(items: any[]): string[] {
    return this.distict(
      this.flat(items).reduce((acc, val) => acc.concat(AOString.keywords(val)), [])
    );
  }

}
